import React, { HTMLAttributes } from 'react';
import { useSelector } from 'react-redux';

import {
  Menu,
} from '@uncinc/react-drupal-core';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useClasses from '../../../hooks/useClasses';
import { ImmutableMenuItem } from '..';
import MenuTabbarItem from './Item';
import SkeletonWrapper from '../../../components/SkeletonWrapper';

import './style.scss';

const MENU_TABBAR_BREAKPOINT = 768;

const MenuTabbar: React.FC<React.HTMLProps<HTMLAttributes<HTMLMenuElement>>> = ({ className }) => {
  const { buildClass, joinClasses } = useClasses('MenuTabbar');
  const menuLoaded = useSelector<ImmutableRootState<object>, object>((state) => state.getIn(['menu', 'tabbar'], null));
  const isLoading = !menuLoaded;

  const navRef = React.useRef<HTMLElement>();

  React.useEffect(() => {
    const nav = navRef.current;

    if (!nav) {
      return;
    }

    function setOffset() {
      const documentWidth = document.body.clientWidth;
      const navHeight = nav.getBoundingClientRect().height;

      if (documentWidth >= MENU_TABBAR_BREAKPOINT) {
        document.documentElement.style.scrollPaddingBottom = '0px';

        return;
      }

      document.documentElement.style.scrollPaddingBottom = `${navHeight}px`;
    }

    setOffset();

    window.addEventListener('resize', setOffset);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('resize', setOffset);
      document.documentElement.style.scrollPaddingBottom = '0px';
    };
  }, []);

  return (
    <nav className={joinClasses(buildClass(), className)} ref={navRef}>
      {isLoading && [...Array(5).keys()].map((item) => (
        <SkeletonWrapper key={`tabbar-loader-${item}`} active className={buildClass('skeleton')} />
      ))}
      <Menu id="tabbar">
        {(entities: ImmutableMenuItem[]) => (
          <ul className={buildClass('list')}>
            {entities.map((entity) => (
              <MenuTabbarItem entity={entity} />
            ))}
          </ul>
        )}
      </Menu>
    </nav>
  );
};

export default MenuTabbar;
